// extracted by mini-css-extract-plugin
export default {"content":"Webinar1_content__2qeHt","title":"Webinar1_title__LncJY","paragraph":"Webinar1_paragraph__l+k4L"};